import { ItemName, Locale } from '@ps-smart-cp/ppfw-client';

const buttonNames = {
  toNext: ItemName.of([Locale.ja, '次へ']),
  login: ItemName.of([Locale.ja, 'ログイン']),
  cancel: ItemName.of([Locale.ja, 'キャンセル']),
  continueWithSso: ItemName.of([Locale.ja, 'SSOで続ける']),
  post: ItemName.of([Locale.ja, '送信']),
  return: ItemName.of([Locale.ja, '戻る']),
  stop: ItemName.of([Locale.ja, '中止']),
  autoJudge: ItemName.of([Locale.ja, '自動判定']),
  reAutoJudge: ItemName.of([Locale.ja, '再測定']),
  search: ItemName.of([Locale.ja, '検索']),
  executionResult: ItemName.of([Locale.ja, '実行結果']),
  outputFile: ItemName.of([Locale.ja, '出力ファイル'], [Locale.en, 'Output File']),
  errorLog: ItemName.of([Locale.ja, 'エラーログ'], [Locale.en, 'Error Log']),
};

const labelNames = {
  organizationId: ItemName.of([Locale.ja, '組織ID']),
  userId: ItemName.of([Locale.ja, 'ユーザーID']),
  email: ItemName.of([Locale.ja, 'メールアドレス']),
  password: ItemName.of([Locale.ja, 'パスワード']),
  verificationCode: ItemName.of([Locale.ja, '認証コード']),
  display: ItemName.of([Locale.ja, '表示']),
  hidden: ItemName.of([Locale.ja, '非表示']),
  sandbox: ItemName.of([Locale.ja, 'Sandbox']),
  enterVerificationCode: ItemName.of([
    Locale.ja,
    '認証アプリに表示されている6桁の認証コードを入力してください。',
  ]),
  range: ItemName.of([Locale.ja, '範囲']),
  importConfirmRecordSizeTip: ItemName.of(
    [Locale.ja, '{0}件のデータを取り込みます。'],
    [Locale.en, 'Import {0} records.'],
  ),
  importConfirmTip: ItemName.of([Locale.ja, 'よろしいですか?'], [Locale.en, 'Are you sure?']),
  selectDataFileToImport: ItemName.of(
    [Locale.ja, '取り込むデータファイルを選択してください。'],
    [Locale.en, 'Select data file to import'],
  ),
  selectToBeDeletedDataFileToImport: ItemName.of(
    [Locale.ja, '削除する契約情報を指定したデータファイルを選択してください。'],
    [Locale.en, 'Select data file specifying to be deleted contract information to import'],
  ),
  confirmTransitionToLeaseLiabilityEstimateChange: ItemName.of([
    Locale.ja,
    '支払情報の変更があるため、リース見積変更する必要があります。 このままリース見積変更に遷移しますか？',
  ]),
  useInputSupport: ItemName.of([Locale.ja, '入力補助を使用する'], [Locale.en, 'Use Input Support']),
  impairmentInfo: ItemName.of([Locale.ja, '減損情報']),
  retireInfo: ItemName.of([Locale.ja, '除却情報']),
  depreciationItemChangeInfo: ItemName.of([Locale.ja, '償却項目変更情報']),
  acquiredMergerInfo: ItemName.of([Locale.ja, '合併受入情報']),
  leaseInformation: ItemName.of([Locale.ja, 'リース情報']),
  autoJudgeInfo: ItemName.of([Locale.ja, '自動判定情報']),
  autoJudge: ItemName.of([Locale.ja, '自動判定']),
  leaseAssetInfo: ItemName.of([Locale.ja, 'リース資産情報']),
  autoJudgeResultInfo: ItemName.of([Locale.ja, '自動判定結果情報']),
  count: ItemName.of([Locale.ja, '件']),
  judgeResultInfo: ItemName.of([Locale.ja, '判定結果情報']),
  execute: ItemName.of([Locale.ja, '行う']),
  transitionConfirmation: ItemName.of([Locale.ja, '画面遷移確認']),
  customFieldChangeInfo: ItemName.of([Locale.ja, 'カスタムフィールド変更情報']),
  noPermissionErrorMsg: ItemName.of([Locale.ja, '【エラー】権限がありません。']),
  bookInfo: ItemName.of([Locale.ja, '帳簿情報']),
};

const linkNames = {
  adminHere: ItemName.of([Locale.ja, '管理者はこちら']),
  sandboxLoginHere: ItemName.of([Locale.ja, 'Sandboxへのログインはこちら']),
  selectCompany: ItemName.of([Locale.ja, '会社を選択']),
  toMainMenu: ItemName.of([Locale.ja, 'メインメニューへ']),
  toSystemManagement: ItemName.of([Locale.ja, 'システム管理']),
  changePassword: ItemName.of([Locale.ja, 'パスワード変更']),
  mfaSetting: ItemName.of([Locale.ja, 'MFA設定']),
  logout: ItemName.of([Locale.ja, 'ログアウト']),
  webhookToken: ItemName.of([Locale.ja, 'トークン管理']),
};

const titleNames = {
  login: ItemName.of([Locale.ja, 'ログイン']),
  adminLogin: ItemName.of([Locale.ja, '管理者のログイン']),
  sandboxLogin: ItemName.of([Locale.ja, 'Sandboxへのログイン']),
  mfaVerification: ItemName.of([Locale.ja, '認証コードの入力']),
  noPermissionErrorTitle: ItemName.of([Locale.ja, '権限エラー']),
  errorLog: ItemName.of([Locale.ja, 'エラーログ'], [Locale.en, 'Error Log']),
};

export const ui = {
  linkNames,
  labelNames,
  titleNames,
  buttonNames,
};
